




























import { useMutation } from '@vue/apollo-composable';
import {
  computed,
  defineComponent,
  reactive,
  ref,
} from '@vue/composition-api';

import { useFormat } from 'vivat';

import updateVehicle from '@/gql/vehicle/updateVehicle.gql';

const CommonModalWithDriverAbsenceEditor = defineComponent({
  setup() {
    const driverId = ref(-1);
    const modal = ref(null);

    function open(id: number) {
      driverId.value = id;
      (modal.value as any).open();
    }
    function close() {
      driverId.value = -1;
      (modal.value as any).close();
    }

    const NOW = useFormat.date().computerShortDate();
    const NEXTDAY = useFormat.date(useFormat.date().dayjs.add(1, 'day')).computerShortDate();
    const form = reactive({
      reason: 'MAINTENANCE',
      date: {
        from: NOW,
        to: NEXTDAY,
      },
    });

    const pendingEditId = ref(-1);
    const refetchQueries = ['getVehicles', 'getVehicle'];
    const createAbsenceLogMutation = useMutation(updateVehicle, () => ({
      variables: {
        id: driverId.value,
        input: {
          absenceLogs: {
            create: [{
              reason: form.reason,
              effectiveDate: form.date.from,
              leaveUntil: form.date.to,
            }],
          },
        },
      },
      refetchQueries,
    }));
    const updateAbsenceLogMutation = useMutation(updateVehicle, () => ({
      variables: {
        id: driverId.value,
        input: {
          absenceLogs: {
            create: [{
              reason: form.reason,
              leaveUntil: form.date.to,
              effectiveDate: form.date.from,
            }],
          },
        },
      },
      refetchQueries,
    }));
    const computedMutation = computed(() => {
      if (pendingEditId.value > -1) return updateAbsenceLogMutation;
      return createAbsenceLogMutation;
    });
    createAbsenceLogMutation.onDone(() => {
      close();
    });
    updateAbsenceLogMutation.onDone(() => {
      close();
    });

    return {
      modal,
      form,
      computedMutation,

      open,
      close,
    };
  },
});

export default CommonModalWithDriverAbsenceEditor;
